import { RouteObject } from "react-router-dom";
import SmartMeterOemLanding from "./components/landing/landing";
import CreateNeptuneIntegration from "./components/neptune/create/create";
import NeptuneDetailLanding from "./components/neptune/detail/landing/landing";

export interface SmartMeterOemRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SmartMeterOemRoute[];
}
export const ixSmartMeterOemRoutes: SmartMeterOemRoute[] = [
  {
    path: "/integration-hub/smart-meter-oem",
    element: <SmartMeterOemLanding />,
  },
  {
    path: "/smart-meter-oem/:oemType/view",
    element: <NeptuneDetailLanding />,
  },
  {
    path: "/smart-meter-oem/:oemType/view/:id",
    element: <NeptuneDetailLanding />,
  },
  {
    path: "/smart-meter-oem/:oemType/:action",
    element: <CreateNeptuneIntegration />,
  },
  {
    path: "/smart-meter-oem/:oemType/:action/:id",
    element: <CreateNeptuneIntegration />,
  },
];
